import { InjectionToken } from '@angular/core';

/** Whether widgets embed live third-party content, or stand in for it while a board is authored. */
export type DashboardWidgetMode = 'live' | 'authoring';

export const DASHBOARD_WIDGET_MODE = new InjectionToken<DashboardWidgetMode>(
    'DashboardWidgetMode',
    {
        providedIn: 'root',
        factory: (): DashboardWidgetMode => 'live',
    }
);
